export default {
    surgeryCategory: 'دسته‌بندی جراحی',
    surgeryCategoryTitle: 'عنوان',
    surgeryCategoryStatus: 'وضعیت',
    surgeryCategories: 'مدیریت دسته‌بندی جراحی‌ها',
    editSurgeryCategory: 'ویرایش دسته‌بندی جراحی',
    addSurgeryCategory: 'دسته‌بندی جراحی‌ جدید',
}